import request from "../../../../../base/request";

const urlMap = {
    picture:"/search-server/search/getList/picture/all",
    video:"/search-server/search/getList/video/all",
    audio:"/search-server/search/getList/audio/all",
};
let count = {
    picture:0,
    video:0,
    audio:0
}

const loadList = ({indexName,start,size,search,other})=>{
    return new Promise((resolve, reject) => {
        if(indexName) {
            if(start==1) {
                count[indexName] = 0
            } else if((start-1)*size > count[indexName]) {
                resolve({count:count[indexName],data:[]});
                return
            }
        }
        request({
            url: urlMap[indexName],
            contentType:"json",
            method:"post",
            body:{ pageNum:start,pageSize:size,keyword:search,...other },
            callBack:(data)=>{
                 data && data.data && data.data.map(item=>{
                    item.component = require(`../${indexName}/${indexName}`).default;
                });
                count[indexName] = data.count;
                resolve(data);
            }
        })
    })
};
export default loadList;